module.exports = __webpack_public_path__ + "img/add.e05e9fe1.png";